// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Box, CircularProgress, styled } from "@3778.care/goban";

const FullPageBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  width: "100vw",
  height: "100vh",
  position: "fixed",
  background: "#fafafa",
  zIndex: 100,
}));

const FlexBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

const FullPageLoading = () => {
  return (
    <FullPageBox>
      <FlexBox component="main">
        <CircularProgress color="primary" />
      </FlexBox>
    </FullPageBox>
  );
};

export default FullPageLoading;
